export default function initTabs() {
  document.querySelectorAll('.sub-nav, .tabs-nav').forEach(holder => {
    const links = holder.querySelectorAll('a[href^="#"]:not([href="#"])');
    const activeClass = 'active';
    let prevLink;
    let prevTab;

    const toggleTab = (link, tabItem) => {
      prevTab.classList.remove(activeClass)
      tabItem.classList.add(activeClass)

      prevLink.parentNode.classList.remove(activeClass)
      link.parentNode.classList.add(activeClass)

      prevLink = link;
      prevTab = tabItem;
    }
    
    links.forEach(link => {
      const tabItem = document.querySelector(link.getAttribute('href'))
      
      if(link.parentNode.classList.contains(activeClass)) prevLink = link; 
      if(tabItem.classList.contains(activeClass)) prevTab = tabItem; 

      link.addEventListener('click', e => {
        e.preventDefault();

        toggleTab(link, tabItem);
      });
    })
  });
}
